var ontologyColumns = require('../../../../../models/equipment/ontologyColumns');
var ontologyFields = require('../../../../../models/equipment/ontologyFields');

function buildGroupedColumnsFromElement(element) {
  var columns = element && Array.isArray(element.columns) ? element.columns : [];
  var columnGroups = element && Array.isArray(element.columnGroups) ? element.columnGroups : [];

  if (!columnGroups.length) {
    return {
      orderedColumns: columns,
      groupedColumns: []
    };
  }

  var orderedColumns = [];
  var groupedColumns = [];
  var cursor = 0;

  columnGroups.forEach(function (group, idx) {
    var width = Number(group && group.width) || 0;
    var groupColumns = columns.slice(cursor, cursor + width);
    cursor += width;

    if (!groupColumns.length) {
      return;
    }

    groupedColumns.push({
      key: (group && group.name) || ('group-' + idx),
      name: ((group && group.name) || '').trim(),
      width: groupColumns.length,
      columns: groupColumns
    });
    orderedColumns = orderedColumns.concat(groupColumns);
  });

  if (cursor < columns.length) {
    var remainingColumns = columns.slice(cursor);
    groupedColumns.push({
      key: 'group-remainder',
      name: 'Other',
      width: remainingColumns.length,
      columns: remainingColumns
    });
    orderedColumns = orderedColumns.concat(remainingColumns);
  }

  return {
    orderedColumns: orderedColumns,
    groupedColumns: groupedColumns
  };
}

function getClassDefData(classDef) {
  if (!classDef || typeof classDef !== 'object') return null;
  return classDef.data && typeof classDef.data === 'object' ? classDef.data : classDef;
}

function titleCaseFieldName(fieldName) {
  return String(fieldName || '')
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, function (character) {
      return character.toUpperCase();
    });
}

function buildFieldColumns(fields, options) {
  var sourceFields = ontologyFields.normalizeFieldDefinitions(fields);
  var excludedFields = Array.isArray(options && options.excludeFields) ? options.excludeFields : [];
  var excludedSet = new Set(excludedFields.map(function (field) {
    return String(field);
  }));

  return sourceFields
    .map(function (field) {
      var normalizedField = ontologyFields.normalizeFieldDefinition(field);
      var fieldName = normalizedField && normalizedField.name;
      var label = normalizedField && (normalizedField.label || normalizedField.name);
      if (!fieldName || !label) return null;
      return {
        name: label,
        fieldName: fieldName,
        kind: normalizedField.kind,
        defaultUnit: normalizedField.defaultUnit
      };
    })
    .filter(function (field) {
      return field && field.fieldName && !excludedSet.has(field.fieldName);
    })
    .map(function (field) {
      var column = {
        name: titleCaseFieldName(field.name),
        type: 'string',
        id: 'field:' + field.fieldName,
        fieldName: field.fieldName
      };
      if (field.kind) {
        column.kind = field.kind;
      }
      if (field.defaultUnit) {
        column.defaultUnit = field.defaultUnit;
      }
      return column;
    });
}

function buildGroupedColumnsFromClassDef(classDef, fallbackColumns) {
  var classDefData = getClassDefData(classDef);
  var datasets = classDefData && Array.isArray(classDefData.datasets) ? classDefData.datasets : [];
  var fallback = Array.isArray(fallbackColumns) ? fallbackColumns : [];

  if (!datasets.length) {
    return {
      orderedColumns: fallback,
      groupedColumns: []
    };
  }

  var orderedColumns = [];
  var groupedColumns = [];
  var usedColumnIds = new Set();

  datasets.forEach(function (dataset, idx) {
    var datasetColumns = ontologyColumns.normalizeColumnDefinitions(dataset && dataset.columns);
    if (!datasetColumns.length) {
      return;
    }

    groupedColumns.push({
      key: (dataset && dataset.id) || (dataset && dataset.name) || ('dataset-' + idx),
      name: ((dataset && dataset.name) || '').trim(),
      width: datasetColumns.length,
      columns: datasetColumns
    });

    datasetColumns.forEach(function (column) {
      orderedColumns.push(column);
      if (column && typeof column.id !== 'undefined' && column.id !== null) {
        usedColumnIds.add(String(column.id));
      }
    });
  });

  var extraColumns = fallback.filter(function (column) {
    if (!column || typeof column.id === 'undefined' || column.id === null) {
      return true;
    }
    return !usedColumnIds.has(String(column.id));
  });

  if (extraColumns.length) {
    groupedColumns.push({
      key: 'group-extra-columns',
      name: 'Other',
      width: extraColumns.length,
      columns: extraColumns
    });
    orderedColumns = orderedColumns.concat(extraColumns);
  }

  return {
    orderedColumns: orderedColumns,
    groupedColumns: groupedColumns
  };
}

function buildFieldColumnsFromClassDef(classDef, options) {
  var classDefData = getClassDefData(classDef);
  var fields = classDefData && Array.isArray(classDefData.fields) ? classDefData.fields : [];
  return buildFieldColumns(fields, options);
}

module.exports = {
  buildFieldColumns: buildFieldColumns,
  buildGroupedColumnsFromElement: buildGroupedColumnsFromElement,
  buildGroupedColumnsFromClassDef: buildGroupedColumnsFromClassDef,
  buildFieldColumnsFromClassDef: buildFieldColumnsFromClassDef
};
